package com.nnod.landing

import kotlin.time.ExperimentalTime
import kotlin.time.Instant
import kotlinx.datetime.TimeZone
import kotlinx.datetime.number
import kotlinx.datetime.toLocalDateTime

@OptIn(ExperimentalTime::class)
internal fun formatScheduledTimeForDisplay(
    value: String,
    timeZone: TimeZone = TimeZone.currentSystemDefault(),
): String {
    return try {
        val scheduledTime = Instant.parse(value).toLocalDateTime(timeZone)
        "${scheduledTime.year.toString().padStart(4, '0')}/" +
            "${scheduledTime.month.number.toString().padStart(2, '0')}/" +
            "${scheduledTime.day.toString().padStart(2, '0')} " +
            "${scheduledTime.hour.toString().padStart(2, '0')}:" +
            "${scheduledTime.minute.toString().padStart(2, '0')}:" +
            scheduledTime.second.toString().padStart(2, '0')
    } catch (_: IllegalArgumentException) {
        value
    }
}
